import apiService from './api-service';

const Users = {};
const urlEntity = "/users";

Users.all = (q = null, limit = null, page = null) => {
    if (q) {
        q.limit = limit;
        q.page = page;
    } else {
        q = {};
        q.limit = limit;
        q.page = page;
    }
    return apiService.get(urlEntity, {
        params: q,
    })
        .then((res) => res)
};

Users.getOne = (id) => {
    return apiService.get(`${urlEntity}/${id}`)
        .then((res) => res)
};

Users.getOneByHash = (hash) => {
    return apiService.get(`${urlEntity}/get-by-hash/${hash}`)
        .then((res) => res)
};

Users.getAll = () => {
    return apiService.get(`${urlEntity}/all`)
        .then((res) => res)
};

Users.add = (data) => {
    return apiService.post(urlEntity, data)
        .then((res) => res)
};

Users.edit = (id, data) => {
    return apiService.put(`${urlEntity}/${id}`, data)
        .then((res) => res)
};

Users.updateAccount = (id, data) => {
    return apiService.put(`${urlEntity}/update-account/${id}`, data)
        .then((res) => res)
};

Users.delete = (id) => {
    return apiService.delete(`${urlEntity}/${id}`)
        .then((res) => res)
};

Users.existEmail = (email, currentEmail) => {
    var q = {};
    if (email) {
        q.email = email;
    }
    if (currentEmail) {
        q.current_email = currentEmail;
    }
    return apiService.get(`${urlEntity}/exist-email`, {
        params: q,
    })
        .then((res) => res)
};

Users.existUsername = (username, currentUsername) => {
    var q = {};
    if (username) {
        q.username = username;
    }
    if (currentUsername) {
        q.current_username = currentUsername;
    }
    return apiService.get(`${urlEntity}/exist-username`, {
        params: q,
    })
        .then((res) => res)
};

Users.currentPassword = (data) => {
    return apiService.post(`${urlEntity}/current-password`, data)
        .then((res) => res)
};

Users.changePassword = (id, data) => {
    return apiService.put(`${urlEntity}/change-password/${id}`, data)
        .then((res) => res)
};

Users.changePasswordRecover = (id, data) => {
    return apiService.put(`${urlEntity}/change-password-recover/${id}`, data)
        .then((res) => res)
};

Users.resetPassword = (id, data) => {
    return apiService.put(`${urlEntity}/reset-password/${id}`, data)
        .then((res) => res)
};

Users.debtcollectorSelectAll = (name = null) => {
    var q = {};
    if (name) {
        q.name = name;
    }
    return apiService.get(`${urlEntity}/debtcollector-select-all`, {
        params: q,
    })
        .then((res) => res);
};

export default Users;
